import * as React from "react";
import type { SVGProps } from "react";
const Hardware = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7068)">
      <path
        fill="currentColor"
        d="M5.3333 5.0005C4.0463 5.0005 3 6.0468 3 7.3338v.2698c0 .248.1604.4594.3682.5943.4813.3135.7985.8531.7985 1.4692s-.3172 1.1558-.7985 1.4693c-.2078.1349-.3682.3464-.3682.5943v2.6031h21v-2.6031c0-.2479-.1604-.4594-.3682-.5943-.4813-.3135-.7985-.8531-.7985-1.4693 0-.616.3172-1.1557.7985-1.4692.2078-.135.3682-.3464.3682-.5943v-.2698c0-1.287-1.0464-2.3333-2.3333-2.3333zM24 15.5005H3v2.3333c0 .6453.5214 1.1667 1.1667 1.1667h1.75v-1.1667c0-.3208.2625-.5833.5833-.5833s.5833.2625.5833.5833v1.1667h3.5v-1.1667c0-.3208.2625-.5833.5834-.5833.3208 0 .5833.2625.5833.5833v1.1667h3.5v-1.1667c0-.3208.2625-.5833.5833-.5833s.5834.2625.5834.5833v1.1667h3.5v-1.1667c0-.3208.2625-.5833.5833-.5833s.5833.2625.5833.5833v1.1667h1.75A1.1655 1.1655 0 0 0 24 17.8338zm-14-7v2.3333a1.1654 1.1654 0 0 1-1.1667 1.1667 1.1654 1.1654 0 0 1-1.1666-1.1667V8.5005c0-.6453.5213-1.1667 1.1666-1.1667S10 7.8552 10 8.5005m4.6667 0v2.3333A1.1655 1.1655 0 0 1 13.5 12.0005a1.1655 1.1655 0 0 1-1.1667-1.1667V8.5005c0-.6453.5214-1.1667 1.1667-1.1667s1.1667.5214 1.1667 1.1667m4.6666 0v2.3333a1.1654 1.1654 0 0 1-1.1666 1.1667A1.1655 1.1655 0 0 1 17 10.8338V8.5005c0-.6453.5214-1.1667 1.1667-1.1667s1.1666.5214 1.1666 1.1667"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_7068">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Hardware;
